var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookOfBlackCoverClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.92649 15.1677H16.8687C16.9083 15.1677 16.9467 15.1621 16.9836 15.1533C16.9866 15.1533 16.989 15.1537 16.9919 15.1537C17.2682 15.1537 17.4927 14.9295 17.4927 14.6531V0.50073C17.4927 0.224326 17.2682 0 16.9919 0H16.8697H4.72733H3.92719C2.59439 0 1.51029 1.08436 1.51029 2.41678C1.51029 2.43465 1.5138 2.45161 1.51554 2.46886C1.5138 3.6997 1.49854 15.0095 1.5138 16.4963C1.51285 16.5254 1.50929 16.5538 1.50929 16.5831C1.50929 17.8644 2.51249 18.9132 3.77435 18.9925C3.79966 18.9964 3.82448 19 3.85075 19H16.9919C17.2682 19 17.4926 18.7758 17.4926 18.4993V16.6145C17.4926 16.3382 17.2681 16.1138 16.9919 16.1138C16.7157 16.1138 16.4912 16.3382 16.4912 16.6145V17.9986H3.92649C3.16557 17.9986 2.54442 17.3945 2.5139 16.6411C2.51464 16.6277 2.51708 16.615 2.51683 16.6013C2.51634 16.5793 2.51559 16.5451 2.5151 16.4996C2.55886 15.7581 3.17426 15.1677 3.92649 15.1677ZM4.26792 2.41678C4.26792 2.14038 4.49225 1.91605 4.76865 1.91605C5.04506 1.91605 5.26938 2.14038 5.26938 2.41678V12.588C5.26938 12.8642 5.04506 13.0887 4.76865 13.0887C4.49225 13.0887 4.26792 12.8642 4.26792 12.588V2.41678Z",
    fill: "#83829B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOfBlackCoverClosed);
export default __webpack_public_path__ + "static/media/book-of-black-cover-closed.4b773fa6c8b1972abb56633c13daa0d3.svg";
export { ForwardRef as ReactComponent };